import React from "react"
import "./Service.scss"
import ServiceApi from "./ServiceApi";
import PrestationApi from "./PrestationApi";
import Card from "./Card"

const Service = () => {
  return (
    <>
      <section className='Service' id='Service'>
        <div className='container top'>
          <div className='heading text-center'>
          <h4> NOS PRESTATIONS </h4>
          <h2>&</h2>
          <h1>SERVICES</h1>
          </div>
            <div className='button'>
              <button className='btn_shadow'>
                <h2><span>Aldôlo</span> veille à vous offrir de services de qualités en repondant à vos besoins et aussi à vos objectifs.
                  Nous vous permettrons d’améliorer votre système, d’accroitre votre productivité et de réduire vos coûts,
                  tout en bénéficiant d’un véritable suivi de service interne composé des ingénieurs et experts informatiques
                  compétents à votre service.
                </h2>
              </button>
            </div>
          <div className='content-section mtop d_flex'>
            <div className='left'>
              {/* <div className='heading'>
                <h4>NOS DIFFÈRENTS</h4>
                <h1>SERVICES</h1>
              </div> */}

              <div className='content'>
                {ServiceApi.map((val, id) => {
                  if (val.category === "Services") {
                    return <Card key={id} title={val.title} year={val.year} rate={val.rate} desc={val.desc} />
                  }
                })}


              </div>
            </div>
            <div className='left' id='Prestation'>
              {/* <div className='heading'>
                <h4>NOS</h4>
                <h1>PRESTATIONS</h1>
              </div> */}

              <div className='content'>
                {PrestationApi.map((val, index) => {
                  if (val.category === "Prestation") {
                    return <Card key={index} title={val.title} year={val.year} rate={val.rate} desc={val.desc} />
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Service;
